/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_NotesInputs */

const en_why_listening_advantage_notes = /** @type {(inputs: Why_Listening_Advantage_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights and notes that stay with the paper`)
};

const es_why_listening_advantage_notes = /** @type {(inputs: Why_Listening_Advantage_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resaltados y notas que se quedan con el artículo`)
};

/**
* | output |
* | --- |
* | "Highlights and notes that stay with the paper" |
*
* @param {Why_Listening_Advantage_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_notes = /** @type {((inputs?: Why_Listening_Advantage_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_notes(inputs)
	return en_why_listening_advantage_notes(inputs)
});